// extracted by mini-css-extract-plugin
module.exports = {"shell":"SignupShell_shell__L4tkW","rail":"SignupShell_rail__aQ5QA","brand":"SignupShell_brand__lYRdg","wordmark":"SignupShell_wordmark__TZ7TU","field":"SignupShell_field__EjoSr"};